import { useState } from 'react';
import styled, { css } from 'styled-components';

import { Flex } from '@/components/base';
import Input from '@/components/Inputs/Input';
import Typo from '@/components/Typography/Typo';
import { useSearchDetailContext } from '@/features/GlobalSearch/context/SearchDetailContext';
import useGlobalSearchModalAction from '@/features/GlobalSearch/hooks/useGlobalSearchModalAction';
import service from '@/services/index';
import { radius } from '@/styles/sizes';

const SearchTitle = () => {
  const { searchResult } = useSearchDetailContext();
  const { refreshHistoryList } = useGlobalSearchModalAction();
  const [title, setTitle] = useState(searchResult.title);
  const [editMode, setEditMode] = useState(false);

  const onTitleBlur = async () => {
    if (!searchResult) return;
    setEditMode(false);
    await service.globalSearch.updateSearchTitle(searchResult.alias, title);
    refreshHistoryList();
  };

  if (editMode)
    return (
      <Input
        sizeType="xl"
        css={CommonCss}
        value={title}
        onChange={(e) => {
          setTitle(e.target.value);
        }}
        onBlur={onTitleBlur}
        placeholder="Enter title"
        initFocus
      />
    );
  return (
    <Flex a="center">
      <Style
        onClick={() => setEditMode(true)}
        css={css`
          ${CommonCss};
          height: auto;
          flex: unset;
          width: fit-content;
          align-items: center;
          padding: 0 12px;
        `}
      >
        <Typo type="body1" style={{ fontSize: 24, lineHeight: 1.4 }}>
          {title}
        </Typo>
      </Style>
    </Flex>
  );
};

const CommonCss = css`
  flex: 1;
  height: 48px;
  font-weight: 600;
  font-size: 24px;
  border-color: transparent;
  transform: translateX(-12px);
  border: 1px solid transparent;
  transition: all 0.2s;
  border-radius: ${radius.input}px;
  &:hover {
    background-color: transparent;
    border-color: ${(props) => props.theme.colors.gray400};
  }
  &:focus {
    background-color: ${(props) => props.theme.colors.gray100};
  }
`;

const Style = styled(Flex)``;

export default SearchTitle;
